<template>
  <el-form-item
      :label="label"
      class="flexbox"
      :class="isJyForm ? 'jy-form-select' : 'jy-common-form-object-select'"
      :rules="rules ? [{ required: true, message: '必填', trigger: 'change' }] : []"
  >
    <el-select
        clearable
        v-model="objectInfo.objectStatusId"
        placeholder="请选择"
        @visible-change="visibleChange($event, 1)"
        @change="selectObjectStatus"
        :class="isJyForm ? 'jy-form-select' : 'jy-common-form-object-select'"
        :disabled="objectStatusDisabled"
    >
      <el-option
          v-for="(item, index) in objectStatusOptions"
          :key="index"
          :label="item.val"
          :value="item.confDictId"
      />
    </el-select>

    <el-select
        v-if="localObjectStatusData === 'customer:object_status'"
        clearable
        filterable
        v-model="objectInfo.objectNameId"
        placeholder="请选择"
        @visible-change="visibleChange($event, 2)"
        style="margin-left: 10px"
        :class="isJyForm ? 'jy-form-select' : 'jy-common-form-object-select'"
        @change="selectObjectName"
        :disabled="objectNameDisabled"
        remote
        :remote-method="getNameList"
    >
      <el-option
          v-for="(item, index) in objectNameOptionsData"
          :key="index"
          :label="item.userMemberName + '(' + item.memberId + ')'"
          :value="item.userMemberId"
      />
    </el-select>

    <el-select
        v-else-if="localObjectStatusData === 'dept:object_status'"
        clearable
        filterable
        v-model="objectInfo.objectNameId"
        placeholder="请选择"
        @visible-change="visibleChange($event, 2)"
        style="margin-left: 10px"
        :class="isJyForm ? 'jy-form-select' : 'jy-common-form-object-select'"
        @change="selectObjectName"
        :disabled="objectNameDisabled"
        :remote="false"
        :remote-method="getNameList"
    >
      <el-option
          v-for="(item, index) in objectNameOptionsData"
          :key="index"
          :label="item.storageName"
          :value="item.storageId"
      />
    </el-select>
    <el-select
        v-else-if="localObjectStatusData === 'storage:object_status'"
        clearable
        filterable
        v-model="objectInfo.objectNameId"
        placeholder="请选择"
        @visible-change="visibleChange($event, 2)"
        style="margin-left: 10px"
        :class="isJyForm ? 'jy-form-select' : 'jy-common-form-object-select'"
        @change="selectObjectName"
        :disabled="objectNameDisabled"
        :remote="false"
        :remote-method="getNameList"
    >
      <el-option
          v-for="(item, index) in objectNameOptionsData"
          :key="index"
          :label="item.storageName"
          :value="item.storageId"
      />
    </el-select>
    <el-select
        v-else-if="localObjectStatusData === 'channel:object_status'"
        clearable
        filterable
        v-model="objectInfo.objectNameId"
        placeholder="请选择"
        @visible-change="visibleChange($event, 2)"
        style="margin-left: 10px"
        :class="isJyForm ? 'jy-form-select' : 'jy-common-form-object-select'"
        @change="selectObjectName"
        :disabled="objectNameDisabled"
        :remote="false"
        :remote-method="getNameList"
    >
      <el-option
          v-for="(item, index) in objectNameOptionsData"
          :key="index"
          :label="item.partnerName"
          :value="item.id"
      />
    </el-select>

    <el-select
        v-else-if="localObjectStatusData === 'employee:object_status'"
        clearable
        filterable
        v-model="objectInfo.objectNameId"
        placeholder="请选择"
        @visible-change="visibleChange($event, 2)"
        style="margin-left: 10px"
        :class="isJyForm ? 'jy-form-select' : 'jy-common-form-object-select'"
        @change="selectObjectName"
        :disabled="objectNameDisabled"
        remote
        :remote-method="getNameList"
    >
      <el-option
          v-for="(item, index) in objectNameOptionsData"
          :key="index"
          :label="item.objectName"
          :value="item.objectId"
      />
    </el-select>

    <el-select
        v-else-if="localObjectStatusData === 'ship_airlines:object_status'"
        clearable
        filterable
        v-model="objectInfo.objectNameId"
        placeholder="请选择"
        @visible-change="visibleChange($event, 2)"
        style="margin-left: 10px"
        :class="isJyForm ? 'jy-form-select' : 'jy-common-form-object-select'"
        @change="selectObjectName"
        :disabled="objectNameDisabled"
        :remote="false"
        :remote-method="getNameList"
    >
      <el-option
          v-for="(item, index) in objectNameOptionsData"
          :key="index"
          :label="item.companyName"
          :value="item.id"
      />
    </el-select>

    <el-select
        v-else-if="localObjectStatusData === 'customer_agent:object_status'"
        clearable
        filterable
        v-model="objectInfo.objectNameId"
        placeholder="请选择"
        @visible-change="visibleChange($event, 2)"
        style="margin-left: 10px"
        :class="isJyForm ? 'jy-form-select' : 'jy-common-form-object-select'"
        @change="selectObjectName"
        :disabled="objectNameDisabled"
        :remote="false"
        :remote-method="getNameList"
    >
      <el-option
          v-for="(item, index) in objectNameOptionsData"
          :key="index"
          :label="item.agentName"
          :value="item.id"
      />
    </el-select>

    <el-input
        v-if="localObjectStatusData === 'other:object_status'"
        @change="onInputObjectName"
        :disabled="objectNameDisabled"
        v-model="objectInfo.objectName"
        style="margin-left: 10px"
        :class="isJyForm ? 'jy-form-input' : 'jy-common-form-object-input'"
        placeholder="请选择"
    ></el-input>
  </el-form-item>
</template>

<script>
import utils from "@/assets/js/tool";

export default {
  name: "ObjectComponentsN",
  props: {
    isJyForm: {
      type: Boolean,
      default: true,
    },
    objectStatusDisabled: {
      type: Boolean,
      default: false,
    },
    objectNameDisabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "结算对象：",
    },
    objectStatus: {
      type: String,
      default: "",
    },
    objectStatusId: {
      type: [String,Number],
      default: "",
    },
    objectName: {
      type: String,
      default: "",
    },
    objectNameId: {
      type: [String,Number],
      default: "",
    },
    objectNumber: {
      type: String,
      default: "",
    },
    objectStatusKey: {
      type: String,
      default: "",
    },
    objectStatusDataList: {
      type: Array,
      default: () => [],
    },
    objectNameOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      objectInfo: {
        objectStatus: this.objectStatus,
        objectStatusId: this.objectStatusId,
        objectName: this.objectName,
        objectNameId: this.objectNameId,
        objectNumber: this.objectNumber,
        documentName: "",
        objectKeyType: "",
      },
      objectStatusOptions: [],
      objectNameOptionsData: [],
      localObjectStatusData: this.objectStatusKey,
    };
  },
  watch: {
    // objectStatus(newVal) {
    //   this.objectInfo.objectStatus = newVal;
    // },
    objectStatus: {
      handler(newVal) {
        this.objectInfo.objectStatus = newVal;
        this.initData();
      },
      immediate: true

    },
    // objectStatusId(newVal) {
    //   this.objectInfo.objectStatusId = newVal;
    // },
    objectStatusId: {
      handler(newVal) {
        this.objectInfo.objectStatusId = newVal;
        this.initData();
      },
      immediate: true
    },
    objectStatusKey(newVal) {
      this.localObjectStatusData = newVal;
      this.objectInfo.objectKeyType = newVal;
    },
    objectName(newVal) {
      this.objectInfo.objectName = newVal;
    },
    objectNameId(newVal) {
      this.objectInfo.objectNameId = newVal;
    },
    objectNumber(newVal) {
      this.objectInfo.objectNumber = newVal;
    },
    // objectStatusDataList(newVal) {
    //   console.info("objectStatusDataList", newVal);
    //   this.objectStatusOptions = newVal;
    // },
    objectStatusDataList: {
      handler(newVal) {
        this.objectStatusOptions = newVal;
        this.initData();
      },
      immediate: true
    },
    // objectNameOptions(newVal) {
    //   this.objectNameOptionsData = newVal;
    // },
    objectNameOptions: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          console.info("objectNameOptionsData", newVal);
          this.objectNameOptionsData = newVal;
        }
      },
      immediate: true
    },
  },
  mounted() {
    // this.initData();
  },
  methods: {
    initData() {
      if (this.objectInfo.objectStatusId || this.objectInfo.objectStatus) {
        const matched = this.objectStatusOptions.find(
            (item) =>
                this.objectInfo.objectStatusId === item.confDictId ||
                this.objectInfo.objectStatus === item.val
        );
        if (matched) {
          // this.objectStatusKey = matched.keyType;
          this.localObjectStatusData = matched.keyType;
          this.objectInfo.objectKeyType = matched.keyType;
        }
      }
    },
    visibleChange(val, type) {
      if (val) {
        if (type === 1) {
          utils.getSelectData("object_status", 3).then((res) => {
            this.objectStatusOptions = res.arr;
          });
        } else if (type === 2) {
          let fetchData = () => {
            let promise;
            if (this.localObjectStatusData === "customer:object_status") {
              promise = utils.getSelectData("member_down_list", 9);
            } else if (this.localObjectStatusData === "dept:object_status") {
              promise = utils.getSelectData("dept_choose_list", 1);
            }else if (this.localObjectStatusData === "storage:object_status") {
              promise = utils.getSelectData("storage_choose_list", 1);
            } else if (this.localObjectStatusData === "channel:object_status") {
              promise = utils.getSelectData("partner_channel_choose_list", 1);
            } else if (this.localObjectStatusData === "employee:object_status") {
              promise = utils.getSelectData("employee_choose_list", 1);
            } else if (this.localObjectStatusData === "ship_airlines:object_status") {
              promise = utils.getSelectData("ship_airlines_choose_list", 1);
            } else if (this.localObjectStatusData === "customer_agent:object_status") {
              promise = utils.getSelectData("down_list_customer_agent", 1);
            }

            if (promise) {
              promise.then((res) => {
                let data = res.arr;
                console.info("选择对象data", data)
                if (
                    this.objectInfo.objectNameId &&
                    this.objectInfo.objectName
                ) {
                  const exists = data.some(
                      (item) =>
                          item.userMemberId === this.objectInfo.objectNameId &&
                          item.userMemberName === this.objectInfo.objectName
                  );
                  if (!exists) {
                    data.push({
                      userMemberId: this.objectInfo.objectNameId,
                      userMemberName: this.objectInfo.objectName,
                      memberId: this.objectInfo.objectNameId,
                    });
                  }
                }
                this.objectNameOptionsData = data;
              });
            }
          };

          fetchData();
        }
      }
    },
    getNameList(val) {
      const arrs = [{ conditonKey: "", conditonVal: val }];

      if (this.localObjectStatusData === "customer:object_status") {
        arrs[0].conditonKey = "nickname";
        utils.getSelectData("member_down_list", 9, arrs).then((res) => {
          this.objectNameOptionsData = res.arr;
        });
      } else if (this.localObjectStatusData === "dept:object_status") {
        utils.getSelectData("dept_choose_list", 1).then((res) => {
          this.objectNameOptionsData = res.arr;
        });
      }else if (this.localObjectStatusData === "storage:object_status") {
        utils.getSelectData("storage_choose_list", 1).then((res) => {
          this.objectNameOptionsData = res.arr;
        });
      } else if (this.localObjectStatusData === "channel:object_status") {
        utils.getSelectData("partner_channel_choose_list", 1).then((res) => {
          this.objectNameOptionsData = res.arr;
        });
      } else if (this.localObjectStatusData === "employee:object_status") {
        arrs[0].conditonKey = "objectName";
        utils.getSelectData("employee_choose_list", 1, arrs).then((res) => {
          this.objectNameOptionsData = res.arr;
        });
      } else if (this.localObjectStatusData === "ship_airlines:object_status") {
        utils.getSelectData("ship_airlines_choose_list", 1).then((res) => {
          this.objectNameOptionsData = res.arr;
        });
      }else if (this.localObjectStatusData === "customer_agent:object_status") {
        utils.getSelectData("down_list_customer_agent", 1).then((res) => {
          this.objectNameOptionsData = res.arr;
        });
      }
    },
    selectObjectStatus(val) {
      const arr = this.objectStatusOptions.filter(
          (value) => value.confDictId === val
      );

      this.objectInfo.objectStatusId = String(val);
      this.objectInfo.objectStatus = "";
      this.objectInfo.objectName = "";
      this.objectInfo.objectNameId = "";
      this.objectInfo.objectNumber = "";

      if (arr.length > 0) {
        const obj = arr[0];
        this.objectInfo.objectStatus = obj.val;
        this.localObjectStatusData = obj.keyType;
        this.objectInfo.objectKeyType = obj.keyType;
        this.$emit("returnData", this.objectInfo, this.objectStatusOptions, this.objectNameOptionsData);
      }
    },
    selectObjectName(val) {
      this.objectInfo.objectNameId = val;

      if (this.localObjectStatusData === "customer:object_status") {
        const arr = this.objectNameOptionsData.filter(
            (value) => value.userMemberId === val
        );
        if (arr.length > 0) {
          const obj = arr[0];
          this.objectInfo.objectName = obj.userMemberName;
          this.objectInfo.objectNumber = obj.memberId;
        }
      } else if (this.localObjectStatusData === "dept:object_status") {
        const arr = this.objectNameOptionsData.filter(
            (value) => value.storageId === val
        );
        if (arr.length > 0) {
          const obj = arr[0];
          this.objectInfo.objectName = obj.storageName;
          this.objectInfo.objectNumber = obj.storageNumber;
        }
      }else if (this.localObjectStatusData === "storage:object_status") {
        const arr = this.objectNameOptionsData.filter(
            (value) => value.storageId === val
        );
        if (arr.length > 0) {
          const obj = arr[0];
          this.objectInfo.objectName = obj.storageName;
          this.objectInfo.objectNumber = obj.storageNumber;
        }
      } else if (this.localObjectStatusData === "channel:object_status") {
        const arr = this.objectNameOptionsData.filter(
            (value) => value.id === val
        );
        if (arr.length > 0) {
          const obj = arr[0];
          this.objectInfo.objectName = obj.partnerName;
          this.objectInfo.taxNo = obj.taxNo;
          this.objectInfo.objectNumber = obj.partnerNumber;
        }
      } else if (this.localObjectStatusData === "employee:object_status") {
        const arr = this.objectNameOptionsData.filter(
            (value) => value.objectId === val
        );
        if (arr.length > 0) {
          const obj = arr[0];
          this.objectInfo.objectName = obj.objectName;
          this.objectInfo.objectNumber = obj.objectNumber;
          this.objectInfo.documentName = obj.objectName;
        }
      } else if (this.localObjectStatusData === "ship_airlines:object_status") {
        const arr = this.objectNameOptionsData.filter(
            (value) => value.id === val
        );
        if (arr.length > 0) {
          const obj = arr[0];
          this.objectInfo.objectName = obj.companyName;
          this.objectInfo.objectNumber = obj.number;
        }
      }else if (this.localObjectStatusData === "customer_agent:object_status") {
        const arr = this.objectNameOptionsData.filter(
            (value) => value.id === val
        );
        if (arr.length > 0) {
          const obj = arr[0];
          this.objectInfo.objectName = obj.agentName;
          this.objectInfo.objectNumber = obj.number;
        }
      }

      this.$emit("returnData", this.objectInfo, this.objectStatusOptions, this.objectNameOptionsData);
    },
    onInputObjectName(val) {
      this.objectInfo.objectName = val;
      this.$emit("returnData", this.objectInfo, this.objectStatusOptions, this.objectNameOptionsData);
    },
  },
};
</script>
